import * as React from "react";
const SvgSync = props => <svg width={22} height={22} viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16 19V3M16 3L19 6M16 3L13 6M6 3V19M6 19L9 16M6 19L3 16" fill="none" strokeLinecap="round" strokeLinejoin="round" /></svg>;
export default SvgSync;